import {FC} from 'react';

import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import CompaniesTable from './CompaniesTable/CompaniesTable';

const Companies: FC = () => {
  return (
    <Box sx={{width: '100%'}}>
      <Paper sx={{width: '96%', margin: '0 auto', mt: 4, mb: 4}}>
        <CompaniesTable />
      </Paper>
    </Box>
  );
};

export default Companies;
